const DATA = window.ispData ?? {};

/**
 * Env specific unique telemetry app id
 * @type {string}
 */
export const APP_ID = DATA.appId ?? '';

/**
 * List of 'application' filters consisting of various 'sensorTypes' and
 * each sensorType consisting of various 'optimizations' (variants)
 * @type {object[]}
 */
export const APPLICATIONS = DATA.filters?.applications ?? [];

/**
 * List of 'application' filter options
 * @type {string[]}
 */
export const APPLICATION_OPTIONS = APPLICATIONS.map(application => application.name);

/**
 * Object containing the default 'application', 'sensorType', 'optimization' and 'solutionId'
 * @type {object}
 */
export const DEFAULT_FILTERS = {
	application: APPLICATIONS?.[0].name,
	sensorType: APPLICATIONS?.[0].sensorTypes[0].name,
	optimization: APPLICATIONS?.[0].sensorTypes[0].optimizations[0].name,
	solutionId: APPLICATIONS?.[0].sensorTypes[0].optimizations[0].solutionId,
};

/**
 * Object containing all the localized labels for the app
 * @type {object}
 */
export const LABELS = DATA.labels ?? {};

/**
 * Unique id associated with the page (always present in 'itemId' hidden input)
 * @type {string}
 */
export const PAGE_ID = document.getElementById('itemId')?.value ?? '';

/**
 * Unique rendering id generated on app load or page refresh (used for telemetry tracking)
 * @type {string}
 */
export const RENDERING_ID = crypto.randomUUID();

/**
 * List of sensor solutions each containing pertinent info corresponding to
 * a unique combination of 'application', 'sensorType' and 'optimization'
 * @type {object[]}
 */
export const SOLUTIONS = DATA.solutions ?? [];
